import * as keyboard from 'util/Keyboard';

export const TAB: keyboard.KeyboardShortcut = {
  matches: keyboard.isTabKey,
  descriptionsForModal: [
    {
      description: 'Navigate to the next cell (right)',
      shortcuts: [{normalizedShortcutText: 'Tab'}],
    },
    {
      description: 'Navigate to the previous cell (left)',
      shortcuts: [{normalizedShortcutText: 'Shift + Tab'}],
    },
  ],
};

export const ENTER: keyboard.KeyboardShortcut = {
  matches: keyboard.isEnterKey,
  descriptionsForModal: [
    {
      description: 'Edit cell / (while editing) Move down',
      shortcuts: [{normalizedShortcutText: 'Enter'}],
    },
    {
      description: 'Finish edit and move up (while editing)',
      shortcuts: [{normalizedShortcutText: 'Shift + Enter'}],
    },
  ],
};

export const F2: keyboard.KeyboardShortcut = {
  matches: (e) => e.key === 'F2',
  descriptionsForModal: [
    {
      description: 'Edit cell',
      shortcuts: [{normalizedShortcutText: 'F2'}],
    },
  ],
};

export const ESCAPE: keyboard.KeyboardShortcut = {
  matches: keyboard.isEscapeKey,
  descriptionsForModal: [
    {
      description: 'Cancel editing / Clear selection',
      shortcuts: [{normalizedShortcutText: 'Esc'}],
    },
  ],
};

export const DELETE: keyboard.KeyboardShortcut = {
  matches: keyboard.isADeleteKey,
  descriptionsForModal: [
    {
      description: 'Clear cell contents',
      shortcuts: [{normalizedShortcutText: 'Delete'}],
    },
  ],
};

export const CTRL_A: keyboard.KeyboardShortcut = {
  matches: keyboard.isCtrlA,
  descriptionsForModal: [
    {
      description: 'Select all cells',
      shortcuts: [{normalizedShortcutText: 'Ctrl + A'}],
    },
  ],
};

export const ARROW_KEYS: keyboard.KeyboardShortcut = {
  matches: keyboard.isAnArrowKey,
  descriptionsForModal: [
    {
      description: 'Move selection in arrow direction',
      shortcuts: [{normalizedShortcutText: 'Arrow Keys'}],
    },
    {
      description: 'Extend selection in arrow direction',
      shortcuts: [{normalizedShortcutText: 'Shift + Arrow'}],
    },
    {
      description: 'Move to edge of data region',
      shortcuts: [{normalizedShortcutText: 'Ctrl + Arrow'}],
    },
    {
      description: 'Extend selection to edge of data region',
      shortcuts: [{normalizedShortcutText: 'Ctrl + Shift + Arrow'}],
    },
  ],
};

/** EXPERIMENTAL SHORTCUTS (under config flag) */

export const SHIFT_SPACE: keyboard.KeyboardShortcut = {
  matches: keyboard.isShiftSpace,
  descriptionsForModal: [
    {
      description: 'Select current row',
      shortcuts: [{normalizedShortcutText: 'Shift + Space'}],
    },
  ],
};

export const CTRL_SPACE: keyboard.KeyboardShortcut = {
  matches: keyboard.isCtrlSpace,
  descriptionsForModal: [
    {
      description: 'Select current column',
      shortcuts: [{normalizedShortcutText: 'Ctrl + Space', skipOsTranslation: true}],
    },
  ],
};

// Navigation to edges
export const HOME: keyboard.KeyboardShortcut = {
  matches: keyboard.isHomeKey,
  descriptionsForModal: [
    {
      description: 'Jump to start of row',
      shortcuts: [{normalizedShortcutText: 'Home'}],
    },
  ],
};

export const END: keyboard.KeyboardShortcut = {
  matches: keyboard.isEndKey,
  descriptionsForModal: [
    {
      description: 'Jump to end of row',
      shortcuts: [{normalizedShortcutText: 'End'}],
    },
  ],
};

export const PAGE_UP: keyboard.KeyboardShortcut = {
  matches: keyboard.isPageUpKey,
  descriptionsForModal: [
    {
      description: 'Jump to top of column',
      shortcuts: [{normalizedShortcutText: 'PageUp'}],
    },
  ],
};

export const PAGE_DOWN: keyboard.KeyboardShortcut = {
  matches: keyboard.isPageDownKey,
  descriptionsForModal: [
    {
      description: 'Jump to bottom of column',
      shortcuts: [{normalizedShortcutText: 'PageDown'}],
    },
  ],
};

export const SHIFT_ENTER: keyboard.KeyboardShortcut = {
  matches: keyboard.isShiftEnter,
  descriptionsForModal: [
    {
      description: 'Insert new row below',
      shortcuts: [{normalizedShortcutText: 'Shift + Enter'}],
    },
  ],
};

export const EXPERIMENTAL_TABLE_SHORTCUTS = [
  SHIFT_SPACE,
  CTRL_SPACE,
  HOME,
  END,
  PAGE_UP,
  PAGE_DOWN,
  SHIFT_ENTER,
];

export const TABLE_SHORTCUTS = [TAB, ENTER, F2, ESCAPE, ARROW_KEYS, CTRL_A];
